import { Links } from './../../businesses/models/businessLink';
import { Injectable } from '@angular/core';
import {
  AboutKuba,
  Activity,
  DashboardLoginCountDto,
  DeviationCount,
  Riskanalysis
} from './../models/dashboard';
import { DashboardService } from './dashboard.services';
import { Observable, of } from 'rxjs';
import { BaseServices } from '../../kuba.services';
import { News } from '../../news/models/news';
import { Roles } from 'src/app/_models/feature';

function viewedBusinessId(): number {
  const roleId = Number(BaseServices.roleId);

  return roleId === Roles.ADMIN || roleId === Roles.PORTAL
    ? 0
    : BaseServices.BusinessId;
}

@Injectable()
export class DashboardActivityResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<Activity[]> {
    if (BaseServices.roleId === '1' || BaseServices.roleId === '2') {
      return this.backend.getFutureAdminActivityByBusiness();
    } else {
      return this.backend.getFutureActivityByBusiness(BaseServices.BusinessId);
    }
  }
}
@Injectable()
export class DashboardDeviationResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<DeviationCount> {
    if (BaseServices.roleId === '1') {
      return this.backend.getAdminDeviation(BaseServices.BusinessId);
    } else {
      return this.backend.getDeviationByBusiness(BaseServices.BusinessId);
    }
  }
}
@Injectable()
export class DashboardDeviationCountForUsers {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<any[]> {
    return this.backend.getDeviationByUser();
  }
}

@Injectable()
export class DashboardRiskAnalysisResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<Riskanalysis[]> {
    return this.backend.getRiskAnalysis(BaseServices.BusinessId);
  }
}
@Injectable()
export class DashboardNewsResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<News[]> {
    if (BaseServices.roleId === '1' || BaseServices.roleId === '2') {
      return null!;
    }
    return this.backend.getInternalNews();
  }
}
@Injectable()
export class DashboardAdminNewsResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<News[]> {
    return this.backend.getAdminNews();
  }
}

@Injectable()
export class DashboardBusinessResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<any[]> {
    return this.backend.getBusiness(BaseServices.BusinessId);
  }
}
@Injectable()
export class DashboardBusinessFunctionResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<any[]> {
    return this.backend.getBusinessFunction(BaseServices.BusinessId);
  }
}

@Injectable()
export class DashboardLoggedUserResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<any[]> {
    if (Number(BaseServices.roleId) !== Roles.ADMIN) {
      return this.backend.getUserHits('Web', viewedBusinessId());
    }

    return of([]);
  }
}

@Injectable()
export class DashboardAppLoggedUserResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<any[]> {
    if (Number(BaseServices.roleId) !== Roles.ADMIN) {
      return this.backend.getUserHits('App', viewedBusinessId());
    }

    return of([]);
  }
}

@Injectable()
export class DashboardBusinessLoginResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<DashboardLoginCountDto[]> {
    const roleId = Number(BaseServices.roleId);
    if (roleId === Roles.ADMIN) {
      return this.backend.getBusinessLoginsForApplication(
        BaseServices.ApplicationId
      );
    }

    return of([]);
  }
}

@Injectable()
export class DashboardAboutKubaResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<AboutKuba[]> {
    return this.backend.getAboutKuba(BaseServices.BusinessId);
  }
}

@Injectable()
export class DashboardLinksListResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<Links[]> {
    if (BaseServices.roleId === '2') {
      return this.backend.getLinksByAppAndBusiness(0);
    } else {
      return this.backend.getLinksByAppAndBusiness(BaseServices.BusinessId);
    }
  }
}

@Injectable()
export class AboutKubaIKResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<AboutKuba> {
    return this.backend.getAboutKubaIk(BaseServices.BusinessId);
  }
}

@Injectable()
export class DashboardLinksPortalBusinessResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<any> {
    return this.backend.getIsPortalBusiness(BaseServices.BusinessId);
  }
}
@Injectable()
export class DashboardLinksForPortalBusinessResolver {
  constructor(private backend: DashboardService) {}
  resolve(): Observable<Links[]> {
    return this.backend.getPortalLinks(BaseServices.BusinessId);
  }
}
